import { Box, Stack, Typography } from "@mui/material";

export default function CompteItem({compte}){
    return (
        <Box key={compte._id} sx={{display:'flex', flex:1, flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>
            <Stack direction='column' spacing={-0.5}>
                <Typography>{compte.libelle}</Typography>
                <Typography color="grey">{compte.num_compte}</Typography>
            </Stack>
            <Typography variant="subtitle1" color={compte.solde < 0 ? 'error' : 'valide'}>{compte.solde>0 ? '+' : ''}{compte.solde?.toFixed(2)} €</Typography>
        </Box>
    )
}